import React, { useState } from 'react'
import { useFormik } from "formik";
import * as Yup from "yup";
import SideBar from '../SideBar.js';
import Header from '../../Header/Header.js';
import { useLocation } from 'react-router-dom';
import { useMutation, useQuery } from '@apollo/client';
import { CREATE_TICKET_REMARK, GET_CUSTOMER_TICKET, GET_MESSAGE } from '../../graphql/Query/GetSupport.js';
import { toast } from 'react-toastify';
import SpinLoader from '../../components/SpinLoader.js';
import { FaBriefcase, FaClock, FaTruck } from 'react-icons/fa';
import moment from 'moment';
import { useFileUpload } from '../../Common/PreSignUrl.jsx';
import { IMAGE_URL } from '../../config.js';


const SingleEscalation = () => {
    const { handleFileUpload } = useFileUpload();
    const location = useLocation();
    const [shipmentAttachment, setShipmentAttachment] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const rowData = location?.state?.row;
    const { data, refetch } = useQuery(GET_MESSAGE, {
        variables: {
            ticketId: rowData?.id
        },
        fetchPolicy: "cache-and-network"
    })
    // console.log('✌️data --->', data);
    const [createRemarkMessage, { loading }] = useMutation(CREATE_TICKET_REMARK);
    const formik = useFormik({
        initialValues: {
            message: "",
            attachment: null,
        },
        validationSchema: Yup.object({
            message: Yup.string().required("Message is required"),
            // attachment: Yup.mixed().test(
            //     "fileSize",
            //     "File size must be less than 5MB",
            //     (value) => !value || (value && value.size <= 5 * 1024 * 1024)
            // ),
        }),
        onSubmit: async (values, { resetForm }) => {
            try {
                const messageInput = {
                    sender: "seller",  // customer, seller, or admin
                    message: values.message,
                    attachments: shipmentAttachment ? [shipmentAttachment] : [],
                };

                const response = await createRemarkMessage({
                    variables: {
                        ticketId: rowData?.id, // The ticket ID
                        messageInput,  // Send the message data
                    },
                });

                // console.log('✌️response --->', response);
                if (response?.data?.addMessageToSupport) {
                    toast.success("Remarks added Successfully");
                    resetForm(); // Reset the form after successful submission
                    refetch();
                    setShipmentAttachment("");
                } else {
                    toast.error("Remarks Not Added");
                }
            } catch (err) {
                toast.error(err);
            }
        },
    });

    const handleFileChange = (event, keyPrefix, folderName) => {
        if ((!event?.target?.files || !event?.currentTarget?.files) || event?.target?.files?.length === 0) {
            setIsLoading(false);
            // console.log("===");
        }
        handleFileUpload({
            event,
            keyPrefix,
            setStateCallback: (url) => {
                const newUrl = url.split('/').slice(-2).join('/');
                // console.log('✌️newUrl --->', newUrl);
                setShipmentAttachment(newUrl)
                setIsLoading(false);
            },
            setIsLoading,
            folderName
        });
    }
    return (
        <>
            <Header />

            <div className="flex min-h-screen bg-slate-100 overflow-hidden">
                {/* Sidebar */}

                <SideBar />

                {/* Main Content */}
                <div className="flex-1 space-y-3 md:p-6 py-6 overflow-x-hidden ml-16">
                    <div className='flex  space-x-0 lg:space-x-3 lg:flex-row flex-col'>
                        <div className="min-h-screen w-2/3 bg-gray-100">
                            <div className="flex flex-col  sm:flex-row px-6 md:p-0 sm:justify-between items-start sm:items-center border-b pb-4 mb-4 space-y-3 sm:space-y-0">
                                {/* Title */}
                                <h2 className="text-lg sm:text-xl font-semibold text-gray-900">
                                    Escalation #{rowData?.ticketID} -{rowData?.issue_type}
                                </h2>

                                {/* Button */}
                                {rowData?.awbNo && <button onClick={() => window.open(`/dashshipment?awb=${rowData?.awbNo}`, "_blank")} className="bg-slate-800 text-sm text-white px-4 py-2 rounded-lg hover:bg-slate-900 transition flex items-center gap-2">
                                    <FaTruck />
                                    View Shipment
                                </button>}
                            </div>
                            <div className="max-w-4xl 2xl:max-w-none bg-white p-6 rounded-lg shadow-lg">
                                {/* Header */}



                                {data?.getMessagesByTicketId?.message?.map((msg, index) => (
                                    <div key={index} className="shadow-sm p-0 md:p-4 border-b mt-3">
                                        <p className="text-gray-800 font-semibold">
                                            {msg?.sender === "seller" ? "You" : "UK Logistics"}
                                            <span className="text-gray-500 text-sm ml-2">
                                                {moment(msg?.createdAt).format("DD MMM, YYYY HH:mm")}
                                            </span>
                                        </p>
                                        <p className="text-gray-600 mt-2">
                                            {msg?.message}
                                        </p>
                                        {/* Check if there are attachments */}
                                        {msg?.attachments && msg?.attachments.length > 0 && (
                                            <div className="mt-2">
                                                {msg?.attachments.map((attachment, attIndex) => (
                                                    <a
                                                        key={attIndex}
                                                        href={`${IMAGE_URL}/${attachment}`}  // Replace with actual file storage path
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        download  // Enables file download
                                                        className="text-blue-500 underline mr-2"
                                                    >
                                                        Attachment {attIndex + 1}
                                                    </a>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                ))}

                                {/* Form Section */}
                                <form onSubmit={formik.handleSubmit} className="mt-6">
                                    <div className="shadow-sm p-4 border rounded-lg">
                                        <h3 className="text-lg font-semibold mb-3">Add New Remarks</h3>

                                        {/* Textarea */}
                                        <textarea
                                            name="message"
                                            className="w-full p-3 border rounded-lg focus:ring-1 focus:ring-slate-800 focus:outline-none resize-none"
                                            placeholder="Add your message here"
                                            {...formik.getFieldProps("message")}
                                        />
                                        {formik.touched.message && formik.errors.message && (
                                            <p className="text-red-500 text-sm mt-1">{formik.errors.message}</p>
                                        )}

                                        {/* File Upload */}
                                        <div className="mt-4">
                                            <label className="block text-sm font-medium text-gray-700">Attachments (If any)</label>
                                            <div className="mt-2 border-2 border-dashed border-gray-300 rounded-lg p-4 text-center">
                                                <input
                                                    type="file"
                                                    className="hidden"
                                                    id="file-upload"
                                                    accept="image/*"
                                                    onChange={(e) => handleFileChange(e, "shipmentIssue", "ticket")}
                                                />
                                                <label
                                                    htmlFor="file-upload"
                                                    className="cursor-pointer bg-slate-600 text-white py-2 px-4 rounded-lg hover:bg-slate-700 transition"
                                                >
                                                    Choose File
                                                </label>
                                                <p className="text-sm text-gray-500 mt-2">
                                                    {formik.values.attachment ? formik.values.attachment.name : "No file chosen"}
                                                </p>
                                                <p className="text-xs text-gray-500">Maximum file size: 5 MB</p>
                                                {formik.touched.attachment && formik.errors.attachment && (
                                                    <p className="text-red-500 text-sm">{formik.errors.attachment}</p>
                                                )}
                                            </div>
                                            {shipmentAttachment && (
                                                <div className="mt-4">
                                                    <p className="text-sm font-medium text-gray-700">Image Preview:</p>
                                                    <img
                                                        src={`${IMAGE_URL}/${shipmentAttachment}`}
                                                        alt="Preview"
                                                        className="mt-2 w-full h-auto rounded-lg shadow-md"
                                                    />
                                                </div>
                                            )}
                                        </div>

                                        {/* Submit Button */}
                                        <button
                                            type="submit"
                                            className="w-full mt-4 py-2 bg-slate-700 text-white font-medium rounded-lg hover:bg-slate-800 transition"
                                        >
                                            Submit <span>{loading && <SpinLoader />}</span>
                                        </button>
                                    </div>
                                </form>
                            </div>


                        </div>

                        <div className="bg-white shadow-lg rounded-xl p-4 md:p-6 mt-7 border border-gray-300 text-sm max-w-lg mx-auto">
                            {/* Title */}
                            <h2 className="text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2">
                                Escalation Info
                            </h2>

                            <div className="space-y-4">
                                {/* Raised At */}
                                <div className="flex items-center gap-2 text-gray-600 border-b p-2">
                                    <FaClock className="text-gray-600" />
                                    <span className="font-medium">Raised at:</span>
                                    <span className="font-bold">{moment(rowData?.createdAt).format("MMM D, YYYY")}</span>
                                </div>

                                {/* Pickup Done */}
                                <div className="border-b p-2 flex text-gray-600 justify-between">
                                    <span className="font-semibold text-gray-700"> {rowData?.ticket_type_issue} {" "} {rowData?.issue_type}</span>
                                    {/* <span className="font-semibold">   {rowData?.ticket_type_issue}</span> */}
                                </div>

                                {/* Additional Info */}
                                <div className="grid sm:grid-cols-2 gap-3 text-gray-600">
                                    <div className="border-b p-2">
                                        <span className="font-bold">Raised at:</span>
                                        <span className="ml-1">{moment(rowData?.createdAt).format("MMM D, YYYY")}</span>
                                    </div>
                                    <div className="border-b p-2 text-gray-600">
                                        <span className="font-bold">Status:</span>
                                        <span className="text-blue-500 font-semibold ml-1">{rowData?.order?.status ? rowData?.order?.status : rowData?.status}</span>
                                    </div>
                                </div>

                                {/* Final Status */}
                                <div className="flex items-center gap-2 text-gray-700 border-b p-2">
                                    <FaBriefcase className="text-gray-600" />
                                    <span className="font-medium">Status:</span>
                                    <span className="font-semibold">{rowData?.order?.status ? rowData?.order?.status : rowData?.status}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SingleEscalation
